import './styles.scss';

const TextArea = ({ input, placeholder, onChange }) => (
  <div className="textArea">
    <textarea {...input} onChange={onChange} placeholder={placeholder} />
  </div>
);

export default TextArea;
